export default {
  Symptoms: '#c4ecff',
  'Risk factors': '#d1e2ff',
}
